import styled from 'styled-components/macro';

import { Tr, Th, Td } from '../../components/Table';

export const StyledTr = styled(Tr as any)`
    cursor: pointer;
`;

export const StyledTh = styled(Th as any)`
    width: 25%;
`;

export const StyledTd = styled(Td as any)`
    width: 25%;
`;
